/*
 * Назначение: общий layout приватной зоны админки.
 * Функционал: sidebar + header + main, автозаголовок раздела по URL,
 * поддержка свернутого/развёрнутого сайдбара.
 */

import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";

import { Header } from "./header";
import { Sidebar } from "./sidebar";

/** Сопоставление префикса пути и заголовка раздела. */
const TITLES: Array<{ prefix: string; title: string }> = [
  { prefix: "/dashboard", title: "Дашборд" },
  { prefix: "/knowledge-base", title: "База знаний" },
  { prefix: "/dialogs", title: "Диалоги" },
  { prefix: "/leads", title: "Заявки" },
  { prefix: "/analytics", title: "Аналитика" },
  { prefix: "/settings", title: "Настройки" },
  { prefix: "/integrations", title: "Интеграции" },
  { prefix: "/users", title: "Пользователи" },
  { prefix: "/profile", title: "Профиль" },
  { prefix: "/projects/new", title: "Создать проект" },
];

const STORAGE_KEY_COLLAPSED = "ai-seller-sidebar-collapsed";

export function AdminLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    return localStorage.getItem(STORAGE_KEY_COLLAPSED) === "1";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY_COLLAPSED, collapsed ? "1" : "0");
  }, [collapsed]);

  const title = useMemo(() => {
    const found = TITLES.find((t) => location.pathname.startsWith(t.prefix));
    return found?.title ?? "ИИ-продавец";
  }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden bg-background text-foreground">
      <Sidebar
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((c) => !c)}
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title={title} systemStatus="healthy" />
        <main className="flex-1 overflow-auto">{children}</main>
      </div>
    </div>
  );
}
